import api from 'Application/api/api';

const deleteGeneralProjectFile = (projectId, fileId, cancelToken = null) =>
    api.delete(`project-manager/projects/${projectId}/files/${fileId}`, {
        cancelToken,
    });

export default deleteGeneralProjectFile;
